"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _xor2 = _interopRequireDefault(require("lodash/xor"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _cccisdHiddenBlock = _interopRequireDefault(require("cccisd-hidden-block"));
var _cccisdLaravelNexus = require("cccisd-laravel-nexus");
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _cccisdToggle = _interopRequireDefault(require("cccisd-toggle"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _InfoLabel = _interopRequireDefault(require("../../../components/InfoLabel"));
var _isValidUrl = _interopRequireDefault(require("../../../helpers/isValidUrl"));
var _validate = _interopRequireDefault(require("./BranchedCompletionConfig/validate.js"));
var _IdentifyRespondents = _interopRequireDefault(require("./IdentifyRespondents"));
var _OtherAllowedRoles = _interopRequireDefault(require("./OtherAllowedRoles"));
var _PostSurveyConfig = _interopRequireDefault(require("./PostSurveyConfig"));
var _RepeatConfig = _interopRequireDefault(require("./RepeatConfig"));
var _RespondentConfig = _interopRequireDefault(require("./RespondentConfig"));
var _TargetResponses = _interopRequireDefault(require("./TargetResponses"));
var _TimeConfig = _interopRequireDefault(require("./TimeConfig"));
var _UrlConfig = _interopRequireDefault(require("./UrlConfig"));
var _AutoLogout = _interopRequireDefault(require("./AutoLogout"));
var _admin = require("../../../selectors/admin.js");
var _deploymentsByEndpoint = _interopRequireDefault(require("../../../queries/deploymentsByEndpoint.graphql"));
var _admin2 = require("../../../reducers/admin");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var Boilerplate = window.cccisd.boilerplate;
var Fortress = window.cccisd && window.cccisd.fortress;
var fields = ['allowRetake', 'anonAutoLogoutMessage', 'autoLogout', 'autoLogoutTime', 'branchedCompletionConfig', 'chainEmailFromPawn', 'chainPhoneFromPawn', 'chainLanguageFromPawn', 'closeOnTarget', 'closedMessage', 'closedRoster', 'closesOn', 'completedMessage', 'completionMessage', 'completionUrl', 'otherAllowedRoles', 'endpoint', 'handle', 'hash', 'individualPasscode', 'isAssignmentPlanEligible', 'isRepeated', 'knownAutoLogoutMessage', 'logoutOnCompletion', 'metricToRespondentPropertyMappings', 'name', 'open', 'opensOn', 'options', 'passcodeAssistant', 'passcodeBackground', 'passcodeBackgroundUpload', 'passcodeBackgroundColor', 'passcodeCompletionButtonText', 'passcodeLabel', 'postCompletionAction', 'recaptcha', 'repeatInterval', 'requireLogin', 'requirePass', 'respondentConfig', 'respondentSelection', 'showReviewButtonOnCompletion', 'targetResponses', 'timepoint', 'useEndpoint'];
var validate = exports.validate = function validate(values, props) {
  var errors = {};
  if (!values.name || !values.name.trim()) {
    errors.name = 'Name is required';
  }
  if (!values.closedMessage) {
    errors.closedMessage = 'Message is required';
  }
  if (values.passcodeLabel && values.passcodeLabel.length > 30) {
    errors.passcodeLabel = 'Please choose a shorter Passcode Label';
  }
  if (values.passcodeCompletionButtonText && values.passcodeCompletionButtonText.length > 15) {
    errors.passcodeCompletionButtonText = 'Please choose a shorter Button Label';
  }
  if (!values.completedMessage) {
    errors.completedMessage = 'Message is required';
  }
  if (!values.completionMessage) {
    errors.completionMessage = 'Message is required';
  }
  if (values.postCompletionAction === 'url' && !values.completionUrl) {
    errors.completionUrl = 'Please specify a URL';
  }
  if (values.postCompletionAction === 'branch') {
    var branchedCompletionErrors = (0, _validate["default"])(values);
    errors = Object.assign(errors, branchedCompletionErrors);
  }
  if (values.useEndpoint) {
    if (!values.endpoint) {
      errors.endpoint = 'Cannot be empty';
    } else if (!/^[A-Za-z0-9]+$/.test(values.endpoint)) {
      errors.endpoint = 'Please use letters and numbers only';
    }
  }
  if (values.respondentConfig === 'previous' && !values.respondentSelection) {
    errors.respondentSelection = 'A selection is required';
  }
  if (values.options.length === 0) {
    errors.options = 'Select at least one survey';
  }
  if (typeof values.targetResponses === 'number') {
    if (values.targetResponses <= 0) {
      errors.targetResponses = 'Target Responses must be greater than zero';
    }
  }
  if (values.completionUrl) {
    if (!(0, _isValidUrl["default"])(values.completionUrl)) {
      errors.completionUrl = 'URL is invalid';
    }
  } else if (!values.completionMessage) {
    errors.completionMessage = "You must specify a URL if you don't want to show a completion message.";
  }
  if (!values.completedMessage) {
    errors.completedMessage = 'You must set a message.';
  }
  if (!values.closedMessage) {
    errors.closedMessage = 'You must set a message.';
  }
  return errors;
};
var asyncValidate = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(values) {
    var result, isNotUnique;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (!values.endpoint) {
            _context.n = 2;
            break;
          }
          _context.n = 1;
          return _cccisdApollo.client.query({
            query: _deploymentsByEndpoint["default"],
            variables: {
              endpoint: values.endpoint
            }
          });
        case 1:
          result = _context.v;
          isNotUnique = result.data.flows.deploymentList.length > 0 && result.data.flows.deploymentList.filter(function (d) {
            return d.hash !== values.hash;
          }).length;
          if (!isNotUnique) {
            _context.n = 2;
            break;
          }
          return _context.a(2, {
            endpoint: 'This endpoint is already taken.'
          });
        case 2:
          return _context.a(2);
      }
    }, _callee);
  }));
  return function asyncValidate(_x) {
    return _ref.apply(this, arguments);
  };
}();
var CycleForm = function CycleForm(props) {
  var assignmentId = props.assignmentId,
    deployment = props.deployment,
    deploymentId = props.deploymentId,
    groupId = props.groupId,
    handleSubmit = props.handleSubmit,
    isNew = props.isNew,
    numCompleted = props.numCompleted,
    surveyList = props.surveyList,
    restrictionsLevel = props.restrictionsLevel,
    submitFailed = props.submitFailed,
    submitting = props.submitting,
    _props$fields = props.fields,
    chainEmailFromPawn = _props$fields.chainEmailFromPawn,
    chainPhoneFromPawn = _props$fields.chainPhoneFromPawn,
    chainLanguageFromPawn = _props$fields.chainLanguageFromPawn,
    closedRoster = _props$fields.closedRoster,
    handle = _props$fields.handle,
    isAssignmentPlanEligible = _props$fields.isAssignmentPlanEligible,
    name = _props$fields.name,
    options = _props$fields.options,
    recaptcha = _props$fields.recaptcha,
    respondentConfig = _props$fields.respondentConfig,
    timepoint = _props$fields.timepoint;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDeleting = _useState2[0],
    setIsDeleting = _useState2[1];
  var dispatch = (0, _reactRedux.useDispatch)();
  function getBulkUploadDef() {
    return _getBulkUploadDef.apply(this, arguments);
  }
  function _getBulkUploadDef() {
    _getBulkUploadDef = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var response, responseBulkDef;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            if (deploymentId) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2);
          case 1:
            _context2.n = 2;
            return _cccisdAxios["default"].get(Boilerplate.route('api.nexus.bulkupload.deploymentRespondentMetricsDef'), {
              params: {
                deploymentId: deploymentId
              }
            });
          case 2:
            response = _context2.v;
            responseBulkDef = (0, _get2["default"])(response, 'data.result.original.data');
            if (!responseBulkDef) {
              _context2.n = 3;
              break;
            }
            return _context2.a(2, responseBulkDef);
          case 3:
            console.error('Could not retrieve bulk upload definition');
            return _context2.a(2, {});
        }
      }, _callee2);
    }));
    return _getBulkUploadDef.apply(this, arguments);
  }
  function handleDelete() {
    return _handleDelete.apply(this, arguments);
  }
  function _handleDelete() {
    _handleDelete = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var _dryRunResponse$data, _dryRunResponse$data2, _dryRunResponse$data4, _dryRunResponse$data5;
      var dryRunResponse, onSuccess, isTaskMaster, _dryRunResponse$data3, topDescription, _dryRunResponse$data6, _dryRunResponse$data7, description;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            setIsDeleting(true);
            _context4.n = 1;
            return dispatch((0, _admin2.removeWave)(deploymentId, true));
          case 1:
            dryRunResponse = _context4.v;
            onSuccess = function onSuccess() {
              (0, _cccisdNotification["default"])('Data Collection Wave deleted successfully.');
              setIsDeleting(false);
              dispatch((0, _admin2.reloadCurrentProject)());
            }; // backend will do it all in one swoop if no responses or respondents,
            // kicking off TaskMaster during dry run
            isTaskMaster = !!(dryRunResponse !== null && dryRunResponse !== void 0 && (_dryRunResponse$data = dryRunResponse.data) !== null && _dryRunResponse$data !== void 0 && _dryRunResponse$data.taskmasterId);
            if (!isTaskMaster) {
              _context4.n = 2;
              break;
            }
            // TO-DO: handle error case here someday, after fixes to cccisd-axios
            onSuccess();
            return _context4.a(2);
          case 2:
            if (!((dryRunResponse === null || dryRunResponse === void 0 ? void 0 : (_dryRunResponse$data2 = dryRunResponse.data) === null || _dryRunResponse$data2 === void 0 ? void 0 : _dryRunResponse$data2.status) !== 'success')) {
              _context4.n = 3;
              break;
            }
            (0, _cccisdNotification["default"])({
              message: 'Error deleting this Data Collection Wave',
              type: 'danger',
              data: dryRunResponse === null || dryRunResponse === void 0 ? void 0 : (_dryRunResponse$data3 = dryRunResponse.data) === null || _dryRunResponse$data3 === void 0 ? void 0 : _dryRunResponse$data3.errors,
              duration: 0
            });
            setIsDeleting(false);
            return _context4.a(2);
          case 3:
            topDescription = /*#__PURE__*/_react["default"].createElement("p", null, "All responses in this Data Collection Wave will be permanently deleted.");
            if (dryRunResponse !== null && dryRunResponse !== void 0 && (_dryRunResponse$data4 = dryRunResponse.data) !== null && _dryRunResponse$data4 !== void 0 && (_dryRunResponse$data5 = _dryRunResponse$data4.data) !== null && _dryRunResponse$data5 !== void 0 && _dryRunResponse$data5.hasRespondents) {
              topDescription = dryRunResponse !== null && dryRunResponse !== void 0 && (_dryRunResponse$data6 = dryRunResponse.data) !== null && _dryRunResponse$data6 !== void 0 && (_dryRunResponse$data7 = _dryRunResponse$data6.data) !== null && _dryRunResponse$data7 !== void 0 && _dryRunResponse$data7.hasResponses ? /*#__PURE__*/_react["default"].createElement("p", null, "All respondents in this Data Collection Wave will be removed, and all their responses in this Data Collection Wave will be permanently deleted.") : /*#__PURE__*/_react["default"].createElement("p", null, "All respondents in this Data Collection Wave will also be removed.");
            }
            description = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, topDescription, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("b", null, "This cannot be undone.")));
            (0, _cccisdConfirm["default"])({
              message: 'Confirm delete?',
              description: description,
              confirmString: 'DELETE',
              confirmLabel: 'Yes',
              abortLabel: 'Cancel'
            }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
              var _actualResponse$data;
              var actualResponse;
              return _regenerator().w(function (_context3) {
                while (1) switch (_context3.n) {
                  case 0:
                    _context3.n = 1;
                    return dispatch((0, _admin2.removeWave)(deploymentId, false));
                  case 1:
                    actualResponse = _context3.v;
                    // actual execution should definitely be a TaskMaster | TO-DO: error handle
                    if (!(actualResponse !== null && actualResponse !== void 0 && (_actualResponse$data = actualResponse.data) !== null && _actualResponse$data !== void 0 && _actualResponse$data.taskmasterId)) {
                      (0, _cccisdNotification["default"])({
                        message: 'Could not delete Data Collection Wave due to following errors:',
                        type: 'danger',
                        data: actualResponse === null || actualResponse === void 0 ? void 0 : actualResponse.data,
                        duration: 0
                      });
                      setIsDeleting(false);
                    } else {
                      onSuccess();
                    }
                  case 2:
                    return _context3.a(2);
                }
              }, _callee3);
            })));
          case 4:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return _handleDelete.apply(this, arguments);
  }
  function onSurveysChange(surveyHandle) {
    options.onChange((0, _xor2["default"])(options.value, [surveyHandle]));
  }
  var isAllowMetricsUploader = (isSuperUser || isUber || restrictionsLevel !== 'basic') && Fortress.hasAnyAccess(['quest.modify_data', 'quest.admin'], groupId) && Fortress.hasAccess('quest.view_identifiable_data', groupId || -1) && !isNew && (respondentConfig.value === 'manual' || respondentConfig.value === 'managed' && closedRoster.value);
  var isSuperUser = Fortress.isSuperUser();
  var isUber = Fortress.user.acting.role.handle === 'uberadmin';
  var hasRecaptchaKey = window.cccisd && window.cccisd.env.recaptchaKey !== '';
  var canDelete = deployment && deploymentId && (Fortress.hasAnyAccess(['quest.modify_data', 'quest.admin'], groupId) || deployment.lastResponseEnteredAt === null);
  return /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
    field: name,
    label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
      label: "Name",
      tooltip: "What would you like to call this Data Collection Wave?"
    })
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
    field: timepoint,
    label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
      label: "Timepoint",
      tooltip: "A timepoint label for this Data Collection Wave (e.g., 'Spring')",
      optional: true
    })
  })), (isSuperUser || isUber) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
    field: handle,
    label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
      label: "Handle",
      tooltip: "This is used programmatically; only set it if you know what you are doing.",
      optional: true
    })
  }))), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: options,
    label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
      label: "Surveys",
      tooltip: "Pick the surveys that the respondents will complete."
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].toggleGroup
  }, surveyList.filter(function (survey) {
    return !survey.archived;
  }).map(function (survey) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: survey.surveyId
    }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
      value: options.value.includes(survey.surveyHandle),
      onChange: function onChange() {
        return onSurveysChange(survey.surveyHandle);
      },
      label: survey.label,
      disabled: !survey.readyForDeploy,
      disabledTooltip: "Survey needs to be created in all deployed languages before it can be enabled."
    }));
  }))), /*#__PURE__*/_react["default"].createElement(_TimeConfig["default"], {
    fields: props.fields
  }), isNew && /*#__PURE__*/_react["default"].createElement(_RespondentConfig["default"], {
    fields: props.fields
  }), (isSuperUser || isUber || restrictionsLevel === 'unlimited') && /*#__PURE__*/_react["default"].createElement(_OtherAllowedRoles["default"], {
    fields: props.fields,
    isNew: isNew
  }), /*#__PURE__*/_react["default"].createElement(_UrlConfig["default"], {
    fields: props.fields
  }), respondentConfig.value === 'anonymous' && /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
    title: "Feature is disabled. Contact Technical Support to have this feature enabled.",
    visible: !hasRecaptchaKey
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: recaptcha
  }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
    value: recaptcha.value,
    onChange: function onChange(e) {
      recaptcha.onChange(!recaptcha.value);
    },
    label: "Require user to complete a captcha before beginning survey",
    disabled: !hasRecaptchaKey
  }))), /*#__PURE__*/_react["default"].createElement(_PostSurveyConfig["default"], {
    deploymentId: Number(deploymentId),
    fields: props.fields,
    submitFailed: submitFailed
  }), (respondentConfig.value === 'anonymous' || respondentConfig.value === 'manual') && /*#__PURE__*/_react["default"].createElement(_AutoLogout["default"], {
    fields: props.fields
  }), /*#__PURE__*/_react["default"].createElement(_TargetResponses["default"], {
    fields: props.fields
  }), /*#__PURE__*/_react["default"].createElement(_IdentifyRespondents["default"], {
    assignmentId: Number(assignmentId),
    deploymentId: Number(deploymentId),
    fields: props.fields,
    numCompleted: numCompleted
  }), (isSuperUser || isUber || restrictionsLevel === 'unlimited') && /*#__PURE__*/_react["default"].createElement(_cccisdHiddenBlock["default"], {
    title: "Advanced Settings"
  }, /*#__PURE__*/_react["default"].createElement(_RepeatConfig["default"], {
    fields: props.fields,
    isNew: isNew
  }), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
    field: chainEmailFromPawn,
    label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
      label: "Messages: Custom Pawn Email Location",
      tooltip: "Comma-separated chain from Pawn model in Laravel to custom email (e.g., 'data, myCustomEmail')",
      optional: true
    })
  }), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
    field: chainPhoneFromPawn,
    label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
      label: "Messages: Custom Pawn Phone Location",
      tooltip: "Comma-separated chain from Pawn model in Laravel to custom phone (e.g., 'data, myCustomPhone')",
      optional: true
    })
  }), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
    field: chainLanguageFromPawn,
    label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
      label: "Messages: Default Pawn Language Location",
      tooltip: "Comma-separated chain from Pawn model in Laravel to custom language (e.g., 'data,language')",
      optional: true
    })
  }), respondentConfig.value === 'managed' && /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: closedRoster,
    label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
      label: "Closed roster",
      tooltip: "For managed types only. Off is default. If toggled on, only pawns rostered into this deployment will be able to access (instead of all with selected role)."
    })
  }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
    value: closedRoster.value,
    onChange: function onChange(e) {
      closedRoster.onChange(!closedRoster.value);
    }
  })), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: isAssignmentPlanEligible,
    label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
      label: "Available to select in Assignment Plans",
      tooltip: "If you are using Assignment Plans, set to Yes to make this Data Collection Wave available for selection."
    })
  }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
    value: isAssignmentPlanEligible.value,
    onChange: function onChange(e) {
      isAssignmentPlanEligible.onChange(!isAssignmentPlanEligible.value);
    }
  }))), isAllowMetricsUploader && /*#__PURE__*/_react["default"].createElement(_cccisdHiddenBlock["default"], {
    title: "Metrics Upload"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelNexus.BulkUploader, {
    handle: "deploymentRespondentMetrics",
    loadDefinition: getBulkUploadDef,
    deploymentId: deploymentId,
    trigger: /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-primary"
    }, "Bulk Add Respondent Metrics")
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].submitButtons
  }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
    className: "btn btn-primary",
    isLoading: submitting,
    onClick: handleSubmit,
    isDisabled: submitting || isDeleting
  }), canDelete && /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"]
  // replace trash icon with loading spinner
  , {
    title: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !isDeleting && /*#__PURE__*/_react["default"].createElement(_bin["default"], {
      spaceRight: true
    }), " Delete"),
    className: "btn btn-danger",
    isLoading: isDeleting,
    onClick: handleDelete,
    isDisabled: isDeleting || submitting
  })));
};
CycleForm.propTypes = {
  groupId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  assignmentId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  closeModal: _propTypes["default"].func,
  deploymentId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  deployment: _propTypes["default"].object,
  fields: _propTypes["default"].object,
  handleSubmit: _propTypes["default"].func,
  isNew: _propTypes["default"].bool,
  numCompleted: _propTypes["default"].number,
  setCurrentDeploymentId: _propTypes["default"].func,
  submitFailed: _propTypes["default"].bool,
  submitting: _propTypes["default"].bool,
  surveyList: _propTypes["default"].array,
  restrictionsLevel: _propTypes["default"].string,
  removeWave: _propTypes["default"].func,
  reloadCurrentProject: _propTypes["default"].func
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    restrictionsLevel: (0, _admin.getRestrictionsLevel)(state.assignment.admin)
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, {
  removeWave: _admin2.removeWave,
  setCurrentDeploymentId: _admin2.setCurrentDeploymentId,
  reloadCurrentProject: _admin2.reloadCurrentProject
})((0, _reduxForm.reduxForm)({
  form: 'CycleForm',
  fields: fields,
  validate: validate,
  asyncValidate: asyncValidate,
  asyncBlurFields: ['endpoint'],
  overwriteOnInitialValuesChange: false
})(CycleForm));